import baseApi from "./baseApi";

/**
 * Web Push 관련 백엔드 API 어댑터.
 *  - GET  /push/vapid          → VAPID public key
 *  - POST /push/subscribe      → 브라우저 PushSubscription 등록 (member_seq 는 token 으로 식별)
 *  - POST /push/unsubscribe    → 등록 해제 (endpoint 기준)
 *
 * 응답은 다른 백엔드 API 와 동일하게 { result: { retCode, retMsg, ... } } 형태.
 */

export const getVapidPublicKey = () =>
  baseApi.get("/push/vapid").then(res => {
    const data = res && res.data;
    return (data && (data.publicKey || (data.result && data.result.publicKey))) || null;
  });

export const subscribePush = subscription =>
  baseApi.post("/push/subscribe", subscription);

export const unsubscribePush = endpoint =>
  baseApi.post("/push/unsubscribe", { endpoint });
